import React, { MouseEventHandler } from 'react'
import styles from './IconButton.module.scss'
import { IconName } from '@fortawesome/fontawesome-svg-core'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

export interface IconButtonProps {
    iconName: IconName
    onClick: MouseEventHandler
    type?: 'button' | 'submit' | 'reset' | undefined
    className?: string
    iconClassName?: string
    disabled?: boolean
    buttonStyle?: string
}

const IconButton: React.FC<IconButtonProps> = ({
    iconName,
    type = 'button',
    className = '',
    iconClassName = '',
    onClick,
    disabled = false,
    buttonStyle = 'default'
}: IconButtonProps) => {
    const defaultClasses = styles.IconButton + ' ' + styles[buttonStyle] + ' ' + className

    return (
        <button type={type} className={defaultClasses} onClick={onClick} disabled={disabled}>
            <DynamicFaIcon className={iconClassName} iconName={iconName} />
        </button>
    )
}

export default IconButton
